<template>
  <AdminInputNumber
    v-on="$listeners"
    v-bind="{ ...$attrs, ...$props }"
    suffix="%"
    max="100"
    min="0"
    @keydown.enter.prevent="() => {}"
  />
</template>

<script>
import ValidationRules from '@/constants/ValidationRules'
import AdminInputNumber from '@/components/AdminInputNumber'
export default {
  name: 'AdminInputPercentage',
  components: { AdminInputNumber },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: 'Edit',
    },
  },
  data() {
    return {}
  },
  computed: {
    rules() {
      let rules = [ValidationRules.unsignedNumberRule]
      if (this.min) {
        rules.push(
          (v) =>
            Number(v) >= Number(this.min) ||
            `Enter a number greater than ${this.min}`
        )
      }
      if (this.max) {
        rules.push(
          (v) =>
            Number(v) <= Number(this.max) ||
            `Enter a number less than ${this.max}`
        )
      }
      return rules
    },
  },
}
</script>
